module.exports = __webpack_public_path__ + "static/media/10.7c6761ba.jpeg";